import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { Navigation } from "./Navigation";
import Logo from './images/saada2.png';
import { Header } from './styled';
import styled from "styled-components";
import { GlobalStyle } from './styles/GlobalStyle';

const AppStyle = styled.div`
  direction: rtl;
  padding: 10px;
  overflow: hidden;
`;

function App() {
  return (
    <BrowserRouter>
      <GlobalStyle />
      <AppStyle>
        <Header>
          <img src={Logo} />
          <span>סעדה ומז'אלה כהן</span>
        </Header>
        <Navigation />
      </AppStyle>
    </BrowserRouter>
  );
}

export default App;
